import { selectChangeMessageForReferenceGroup } from '@UI/aside/asideReferenceGroup/asideReferenceGroupSelectors';
import { ContentType } from '@generalTypes/apiTypes';
import { selectReferenceGroupNode } from '@newStore/documentUI/transformContent/referenceGroupSelectors';
import { selectCurriculumThemesValidation } from '@newStore/validation/validationRules/curriculumThemesConsistencyValidation';
import type { BuildingBlockNodeConfig } from '@nodeTypeConfig/configTypes';
import { titleAsDescriptionComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';

const REFERENCE_GROUP: BuildingBlockNodeConfig = {
  nodeSelector: selectReferenceGroupNode,
  validationRules: [selectCurriculumThemesValidation],
  information: {
    single: 'Verwijsgroep',
    plural: 'Verwijsgroepen',
    ribonIcon: require('../../../../img/buildingBlocks/REFERENCE_GROUP.svg'),
  },
  buildingBlocks: [],
  edit: [
    titleAsDescriptionComponent,
    {
      component: 'referenceGroup',
      reactComponent: 'AsideReferenceGroup',
      asideChangeMessageSelector: selectChangeMessageForReferenceGroup,
      label: 'Globale verwijzingen',
      hiddenChildren: {
        containerType: ContentType.REFERENCE_GROUP,
        items: [
          {
            type: ContentType.REFERENCE,
            label: 'verwijzing',
          },
        ],
      },
    },
  ],
  isCollapsible: false,
  hideChildrenInDocument: true,
  onNewNodeDropped: {
    openAside: true,
  },
};

export default REFERENCE_GROUP;
